export default {
  saltBins: [],
  saltBin: undefined,
};
